export type RoadmapStatus = "done" | "coming-next" | "planned" | "exploring";

export interface RoadmapItem {
  title: string;
  body: string;
  status: RoadmapStatus;
  statusLabel: string;
  eta: string;
  date?: string; // for "done" items
}

export const FUTURE_UPDATES: RoadmapItem[] = [
  /* ---- Done / shipped ---- */
  {
    title: "Web-based audits",
    body: "Paste a URL on snapsiteux.com and get captures, responsive comparisons, and UX annotations — no Figma required.",
    status: "done",
    statusLabel: "Shipped",
    eta: "Live",
    date: "April 2026",
  },
  {
    title: "Audit history and Snap Site Score",
    body: "Every audit now gets a 0–100 score weighted by severity. Past audits are saved so you can track improvements over time.",
    status: "done",
    statusLabel: "Shipped",
    eta: "Live",
    date: "March 2026",
  },
  {
    title: "Credit-based plans and top-ups",
    body: "Free, Pro, and Agency plans with monthly credit allowances. One-time top-up packs that stay valid for 12 months.",
    status: "done",
    statusLabel: "Shipped",
    eta: "Live",
    date: "February 2026",
  },
  {
    title: "AI-guided interactions",
    body: "Tell Snap Site to open menus, click toggles, or navigate flows before capturing — so hidden states get audited too.",
    status: "done",
    statusLabel: "Shipped",
    eta: "Live",
    date: "January 2026",
  },

  /* ---- Coming next ---- */
  {
    title: "Continuous monitoring",
    body: "Add your live site once and have Snap Site re-audit on a schedule — emailing you what regressed since the last run.",
    status: "coming-next",
    statusLabel: "Coming next",
    eta: "In progress",
  },
  {
    title: "Competitor tracking",
    body: "Watch sites you care about and get notified when key pages change — new hero copy, redesigned pricing, swapped CTAs.",
    status: "coming-next",
    statusLabel: "Coming next",
    eta: "Up next",
  },

  /* ---- Planned ---- */
  {
    title: "Release checks",
    body: "Run audits before important site changes go live and spot regressions early, with results ready for the team to review.",
    status: "planned",
    statusLabel: "Planned",
    eta: "Next quarter",
  },
  {
    title: "Detailed analysis report",
    body: "A structured printable report that goes beyond the canvas PDF — executive summary, prioritised findings, and recommendations laid out for client handoffs and stakeholder reads.",
    status: "planned",
    statusLabel: "Planned",
    eta: "Next quarter",
  },

  /* ---- Exploring ---- */
  {
    title: "Generated design suggestions",
    body: "Each finding paired with a starting-point design — so reviews come with a direction, not just a critique.",
    status: "exploring",
    statusLabel: "Exploring",
    eta: "Researching",
  },
  {
    title: "Team collaboration",
    body: "Shared projects, pooled credits, and role-based access so agencies and design teams can work on audits together.",
    status: "exploring",
    statusLabel: "Exploring",
    eta: "Researching",
  },
];
